export const pointTemplate = {
  cityId: null, // required
  addressId: null,
  poiId: null,
  latitude: null,
  longitude: null,
  address: null,
  name: null,
  mobile: null,
  nationalId: null,
  floor: null, // required,
  elevator: false, // required
  carDistanceMeter: 10, // required
  plate: null,
  unit: null,
  zipCode: null,
  phone: null,
  email: null,
  weighbridgeWeightKilogram: null,
  weighbridgeReceiptFile: null,
  operationId: null,
  addons: null
}

export default [
  // furniture
  {
    id: 10,
    title: 'load.loadTypes.furniture',
    slug: 'furniture',
    template: {
      typeId: 10, // required
      rangeId: null, // required
      userId: null,
      origin: null, // required
      destinations: [], // required
      orderTime: null,
      estimatedDistanceMeter: null,
      estimatedDurationSecond: null,
      estimatedPolyline: [],
      car: [],
      employee: [],
      item: [],
      courierIds: [],
      description: null,
      attachments: null,
      image: null,
      _orderWithCar: true,
      insuranceNeeded: false,
      loadConditionIds: [],
      paymentTypeId: null,
      paymentName: null,
      paymentMobile: null,
      driverAssignIn: []
    }
  },
  // cargo
  {
    id: 20,
    title: 'load.loadTypes.cargo',
    slug: 'cargo',
    template: {
      typeId: 20, // required
      rangeId: null, // required
      userId: null,
      origin: null, // required
      destinations: [], // required
      orderTime: null, // required
      loadingStartTime: null, // required
      loadingEndTime: null, // required
      loadId: null, // required
      packageTypeId: null, // required
      monetaryValue: null, // required
      weightKilogram: null, // required
      licenses: null,
      car: [],
      description: null,
      attachments: null,
      image: null,
      _licenseIsRequired: false,
      insuranceNeeded: false,
      loadConditionIds: [],
      paymentTypeId: null,
      paymentName: null,
      paymentMobile: null,
      driverAssignIn: [],
      dischargeEndTime: null,
      dischargeStartTime: null,
      dischargeTime: null
    }
  },
  // freight
  {
    id: 90,
    title: 'load.loadTypes.delivery',
    slug: 'freight',
    template: {
      typeId: 90,
      rangeId: null, // required
      userId: null,
      origin: null, // required
      destinations: [], // required
      carCategoryId: null, // required
      monetaryValue: null, // required
      roundTrip: false,
      waitMinute: null,
      description: null,
      attachments: null,
      loadConditionIds: [],
      paymentTypeId: null,
      paymentName: null,
      paymentMobile: null,
      driverAssignIn: []
    }
  }
]
